//TODO refactor - send specific env variable to the remote dev client
export const isDevEnv = () =>
  process.env.NODE_ENV === 'development' ||
  window.location.hostname === 'admin.dev.driver360.org' ||
  window.location.hostname === 'exodus.dev.driver360.org'
//export const isDevEnv = process.env.NODE_ENV === 'development'
